window.addEventListener("load", () => {
  const widgets = document.querySelectorAll(".featured-product");

  widgets.forEach(widget => {
    const selectorElements = widget.querySelectorAll("[data-collection-selector], .collection-tab");
    const slider = widget.querySelector("[data-slider]");
    if (!slider || selectorElements.length === 0) return;

    const allSlides = [...slider.querySelectorAll("[data-slider-item]")];
    const slidesByCollection = {};

    allSlides.forEach(slide => {
      const collectionHandle = slide.dataset.collectionHandle;
      if (!slidesByCollection[collectionHandle]) slidesByCollection[collectionHandle] = [];
      slidesByCollection[collectionHandle].push(slide);
    });

    function showCollection(handle) {
      allSlides.forEach(slide => (slide.style.display = "none"));

      if (handle === "all") {
        allSlides.forEach(slide => (slide.style.display = ""));
      } else if (slidesByCollection[handle]) {
        slidesByCollection[handle].forEach(slide => (slide.style.display = ""));
      }

      if (slider.swiper) {
        slider.swiper.update();
        slider.swiper.slideTo(0);
      }

      selectorElements.forEach(el => {
        if (el.tagName === "BUTTON") {
          el.classList.toggle("active", el.dataset.collection === handle);
        }
      });

      selectorElements.forEach(el => {
        if (el.tagName === "SELECT") {
          el.value = handle;
        }
      });
    }

    selectorElements.forEach(el => {
      if (el.tagName === "SELECT") {
        el.addEventListener("change", e => {
          showCollection(e.target.value);
        });
      } else if (el.tagName === "BUTTON") {
        el.addEventListener("click", e => {
          e.preventDefault();
          const handle = e.currentTarget.dataset.collection;
          showCollection(handle);
        });
      }
    });

    let initialHandle;
    if (selectorElements[0].tagName === "SELECT") {
      initialHandle = selectorElements[0].value || "all";
    } else {
      initialHandle = selectorElements[0].dataset.collection || "all";
    }

    showCollection(initialHandle);
  });
});